import { render, staticRenderFns } from "./song-contribution-show.vue?vue&type=template&id=2185d83c&"
import script from "./song-contribution-show.vue?vue&type=script&lang=js&"
export * from "./song-contribution-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports